import React, {useEffect, useState} from 'react';
import {AppBar, ConfirmDialog, HtmlTooltip, ListViewMode, LoadingProgress, MostrarError} from "../../components";
import {eliminarNotificacion, marcarNotLeida, mostrarNotificaciones} from '../../redux/reducers/notificacionesReducers';
import {
    FormControlLabel,
    IconButton,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import Strings from "../../assets/strings"
import {useLocation, useNavigate} from "react-router-dom";
import {formatDate} from "../../helpers";
import {Close, DoneAllOutlined, FileOpenOutlined} from "@mui/icons-material";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {INotificacion} from "../../redux/types/INotificacion";
import {TIPO_NOTIFICACION} from "../../helpers/CONSTANTES";

function  Notificaciones() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {state:urlState, pathname} = useLocation();
    const [mostrarLeidas, setMostrarLeidas] = useState(true);

    const { list, status, error } = useAppSelector(state=>state.notificaciones);


    useEffect(() => {
        dispatch(mostrarNotificaciones(mostrarLeidas));
    }, [dispatch,mostrarLeidas]);

    const onVewDoc = (noti:INotificacion) => {
        if(!noti.leida) {
            dispatch(marcarNotLeida(noti.id!))
        }

        switch (noti.tipo) {
            case TIPO_NOTIFICACION.SOLICITUD:
                navigate("/solicitud/"+noti.documentoId)
                break
            case TIPO_NOTIFICACION.NOTA_PRESTAMO:
            case TIPO_NOTIFICACION.PAGO_CLIENTE:
                navigate("/prestamo/"+noti.documentoId)
                break
            case TIPO_NOTIFICACION.NUEVO_USUARIO:
                navigate("/appUserDetails/"+noti.documentoId)
                break
        }

    }
    return <>
        <AppBar />

        <section className="contentInner" style={(status === "loading")?{opacity:.8}:{opacity:1}}>
            {(status === "loading") && !list?.length && <LoadingProgress vh/>}
            {!urlState && <MostrarError errors={error}/>}


            <ListViewMode pageRows={list?.length} pageTotalRows={list?.length}>
                <FormControlLabel className="d-print-none"
                                  control={
                                      <Switch
                                          //disableRipple
                                          size={"small"}
                                          color={"secondary"}
                                          checked={mostrarLeidas}
                                          onChange={()=>setMostrarLeidas(!mostrarLeidas)}
                                          value="checkedB"
                                      />
                                  }
                                  label={"Ver leidas"}
                />
            </ListViewMode>

            {/*<Box maxWidth={1000} padding={1} margin={"0 auto"}>*/}
            {/*    <Typography variant={"body2"} sx={{mb:1}}>{formatDate(new Date())}</Typography>*/}
            {/*    {list?.map(item =>*/}
            {/*        <Paper key={item.id} variant={"outlined"} sx={{p:1, mb:1}} className={!item.leida?"bg-blue":""}>*/}
            {/*            <Typography variant={"subtitle2"}>{item.titulo}</Typography>*/}
            {/*            <Typography variant={"body1"}>{item.mensaje}</Typography>*/}
            {/*            <Stack direction="row" spacing={2} marginTop={1}>*/}
            {/*                <Chip size={"small"} label="Marcar leido" color={"secondary"} onClick={()=>dispatch(marcarNotLeida(item.id!))}/>*/}
            {/*                <Chip size={"small"}label="Ver documento" color={"primary"}/>*/}
            {/*                <Chip size={"small"} label="Eliminar"*/}
            {/*                      sx={{*/}
            {/*                        color: "#d84315",*/}
            {/*                        backgroundColor: "#fbe9e7"*/}
            {/*                    }}*/}
            {/*                    onClick={()=>navigate(pathname,{state:{confirmDialog:item.id}})}*/}
            {/*                />*/}
            {/*            </Stack>*/}
            {/*        </Paper>*/}
            {/*    )}*/}
            {/*</Box>*/}


            <TableContainer >
                <Table className={"hasOnclick"}>
                    <TableHead>
                        <TableRow>
                            <TableCell/>
                            <TableCell> {Strings.fecha}</TableCell>
                            <TableCell>{Strings.notificacion}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list?.map(item =>
                            <TableRow key={item.id} sx={!item.leida?{background:"rgba(25, 118, 210, 0.07) !important"}:{}}>
                                {/*className={!!item.gasAnulado ? "text-red-deep":""}*/}
                                <TableCell className="actionCell">
                                    {/*{hasPermissionTo(PERSMISOS.notificacionesEliminar) &&*/}
                                    {(item.tipo !== TIPO_NOTIFICACION.OTROS && item.tipo !== TIPO_NOTIFICACION.MENSAJE_SISTEMA) &&
                                        <HtmlTooltip title={Strings.ver+" "+Strings.documento}>
                                            <IconButton
                                                onClick={()=>onVewDoc(item)}
                                                size="large">
                                                <FileOpenOutlined className={"text-violet"}/>
                                            </IconButton>
                                        </HtmlTooltip>
                                    }
                                    <HtmlTooltip title={Strings.eliminar}>
                                        <IconButton
                                            onClick={()=>navigate(pathname,{state:{confirmDialog:item.id}})}
                                            size="large">
                                            <Close className={"text-red"}/>
                                        </IconButton>
                                    </HtmlTooltip>
                                    {!item.leida && <HtmlTooltip title={"Marcar como leida"}>
                                        <IconButton
                                            onClick={() => dispatch(marcarNotLeida(item.id!))}
                                            size="large">
                                            <DoneAllOutlined className={"text-blue"}/>
                                        </IconButton>
                                    </HtmlTooltip>}
                                    {/*}*/}
                                </TableCell>
                                <TableCell> {formatDate(item.fechaCreacion)} {formatDate(item.fechaCreacion, "hh:mm a")}</TableCell>
                                <TableCell>
                                    <Typography variant={"subtitle2"}>{item.titulo}</Typography>
                                    <Typography variant={"body2"}>{item.mensaje}</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer >



            <ConfirmDialog onConfirm={()=>dispatch(eliminarNotificacion(urlState?.confirmDialog))}>
                <Typography variant={"body1"}>Esta notificación se eliminará para todos los usuarios.</Typography>
            </ConfirmDialog>
        </section>
    </>;


}

export default Notificaciones
